import React from "react";
import * as c from "./index.module.scss";
import { DropdownSectionFeatures } from "./sections";
import DesktopNavbarDropdown from "@components/navbar/desktop/dropdowns/desktopNavbarDropdown";
import classNames from "classnames";

const Column = ({ className, children }) => <div className={className}>{children}</div>;
export default function DropdownFeatures() {
  return (
    <>
      <DesktopNavbarDropdown label="Features">
        <Column className={classNames(c.features, "featuresDropdown")}>
          <DropdownSectionFeatures />
        </Column>
      </DesktopNavbarDropdown>
    </>
  );
}
